<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição de prioridade' : 'Cadastro de prioridade'">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/painel-senha/prioridade/Form'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {Form},
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {
            this.showExitConfirmation(async () => {
                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {
            this.$router.push({name: 'painel-senha-prioridade-index'})
        },
    },
    props: {
        id: {type: Number, default: null}
    },
}
</script>